/**
 * 用户端租户站点配置(构建时固定,与 backweb-tenant tenant-console.ts 对齐)。
 *
 * default 租户即平台门户:访问 default.localhost 或 default.{base_domain}。
 */

/** 从 Host 推导租户 code(子域 / public_host 与 backend 一致) */
export function resolveTenantFromHost(): string | undefined {
  if (typeof window === 'undefined') return undefined
  const host = window.location.hostname.toLowerCase()
  const base = (import.meta.env.VITE_TENANT_BASE_DOMAIN as string | undefined)?.trim()
  if (!base) return undefined
  const suffix = `.${base.toLowerCase()}`
  if (!host.endsWith(suffix)) return undefined
  const sub = host.slice(0, -suffix.length)
  if (!sub || sub === 'www') return undefined
  return sub.split('.')[0] || undefined
}

/** 是否 default 租户门户(平台自营 C 端) */
export function isDefaultTenantPortal(): boolean {
  return getConfiguredTenantCode().toLowerCase() === 'default'
}

/**
 * 当前站点绑定的租户 code(构建时 VITE_TENANT_CODE 优先,其次 Host,开发 fallback default)。
 */
export function getConfiguredTenantCode(): string {
  const fromEnv = (import.meta.env.VITE_TENANT_CODE as string | undefined)?.trim()
  if (fromEnv) return fromEnv
  const fromHost = resolveTenantFromHost()
  if (fromHost) return fromHost
  if (import.meta.env.DEV) {
    console.warn('[tenant-site] VITE_TENANT_CODE 未配置, fallback default')
  } else {
    console.warn('[tenant-site] 生产环境未配置 VITE_TENANT_CODE 或 VITE_TENANT_BASE_DOMAIN')
  }
  return 'default'
}

/** 公开 API 租户解析头,与 backend tenant.header_code 默认一致 */
export const TENANT_HEADER = 'X-Tenant-Code'

/**
 * multi 模式下校验后端解析租户与前端绑定是否一致。
 * @returns 不一致时的错误文案;一致或 single 模式返回 null
 */
export function validateTenantMatch(
  resolvedCode: string | undefined,
  mode?: string,
): string | null {
  if (mode !== 'multi') return null
  const configured = getConfiguredTenantCode()
  const resolved = (resolvedCode ?? '').trim() || 'default'
  if (resolved !== configured) {
    return `租户配置不一致: 前端绑定「${configured}」, 后端解析为「${resolved}」`
  }
  return null
}

export function siteTitle(tenantName?: string): string {
  const code = getConfiguredTenantCode()
  const name = tenantName?.trim()
  return name ? `${name} · SilkReels` : `SilkReels · ${code}`
}
